import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

// Desain ulang tema dengan fokus pada aksesibilitas, kejelasan, dan nuansa profesional.
const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32', // Hijau yang lebih gelap dan aksesibel (Kontras 4.54:1 dengan putih)
      light: '#5a9c5e',
      dark: '#005005',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FFC107', // Kuning amber untuk kontras yang baik sebagai aksen
      contrastText: '#000000',
    },
    background: {
      default: grey[100], // Abu-abu yang sangat terang, lebih lembut dari putih bersih
      paper: '#FFFFFF',
    },
    text: {
      primary: '#212121', // Hitam pekat untuk keterbacaan maksimal
      secondary: '#5f6368', // Abu-abu sekunder yang jelas
    },
    error: {
      main: '#D32F2F', // Merah standar untuk error
    },
    success: {
      main: '#388E3C', // Hijau untuk notifikasi sukses
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700, // Lebih tebal untuk hierarki yang jelas
      fontSize: '2rem',
      color: '#212121',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
      color: '#212121',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: '#333333',
    },
    // Perbesar ukuran font body untuk keterbacaan
    body1: {
      fontSize: '1rem', // 16px
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem', // 14px
      lineHeight: 1.43,
      color: '#5f6368',
    },
    button: {
      textTransform: 'none', // Tombol dengan teks normal, tidak kapital semua
      fontWeight: '600',
    },
  },
  // Komponen global untuk konsistensi
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2E7D32', // Gunakan warna primer baru
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#FFFFFF',
          borderRight: `1px solid ${grey[300]}`,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12, // Sudut lebih membulat dan modern
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)', // Bayangan lebih lembut
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 20px', // Padding lebih besar untuk target klik yang mudah
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    // Zebra-striping dan hover effect untuk semua tabel
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: grey[50], // Warna abu-abu sangat terang untuk baris ganjil
          },
          '&:hover': {
            backgroundColor: grey[200], // Warna highlight saat di-hover
            cursor: 'pointer',
          },
          // Hapus hover effect pada header tabel
          'thead &:hover': {
            backgroundColor: 'transparent',
            cursor: 'default',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 600, // Buat header tabel lebih tebal
          color: '#212121',
        },
      },
    },
  },
});

export default theme;